"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var makeStyles_1 = require("@material-ui/core/styles/makeStyles");
var appointmentDetailsStyles = makeStyles_1.default(function (_a) {
    var palette = _a.palette, typography = _a.typography;
    return ({
        appointmentDetailsWrapper: {
            borderTop: "1px solid " + palette.primaryDisabled.main,
            padding: '20px 0',
        },
        title: {
            fontFamily: typography.fontFamily2,
            paddingBottom: '20px',
        },
        element: {
            padding: '2px 0',
        },
        comments: {},
        titleContent: {},
        elementContent: {},
        configUrl: {
            textTransform: 'uppercase',
            textDecoration: 'underline',
        },
    });
}, { name: 'GqlSummary_AppointmentDetails' });
exports.default = appointmentDetailsStyles;
